import { NavigationChevronLeft, NavigationChevronRight } from '@vibe/icons';
import { useNavigate } from 'react-router-dom';
import { useLocale } from '@/i18n/LocaleProvider';
import { useTranslation } from '@/i18n/useTranslation';
import { isRtlLocale } from '@/lib/planning-report-i18n';
import styles from './ScreenBackButton.module.css';

export interface ScreenBackButtonProps {
  to: string;
  className?: string;
}

export default function ScreenBackButton({ to, className }: ScreenBackButtonProps) {
  const t = useTranslation();
  const navigate = useNavigate();
  const { language } = useLocale();
  const BackIcon = isRtlLocale(language) ? NavigationChevronRight : NavigationChevronLeft;

  return (
    <button
      type="button"
      className={[styles.back, className].filter(Boolean).join(' ')}
      onClick={() =>
        navigate(to, to === '/map' ? { state: { revisiting: true } } : undefined)
      }
      data-testid="screen-back-button"
    >
      <BackIcon size={18} className={styles.icon} />
      {t.wizard.back}
    </button>
  );
}
